// extracted by mini-css-extract-plugin
module.exports = {"class":"AirspaceRow_class__3qIY4","content":"AirspaceRow_content__3O7FL","line":"AirspaceRow_line__3VAJS"};